import React from 'react';

import { SORTABLE_ANALYTICS_FILE_FIELDS } from '@ion/api';

import TimestampCell from 'app/components/data-table/TimestampCell';
import IdentitySyncsCell from 'app/components/data-table/IdentitySyncsCell';

import ActionsCell from './cells/ActionsCell';
import PipelineNameCell from './cells/PipelineNameCell';

export const analyticsFilesTableColumns = [
  {
    name: 'Pipeline',
    cell: row => <PipelineNameCell row={row} />,
    sortable: true,
    sortField: SORTABLE_ANALYTICS_FILE_FIELDS.pipeline,
  },
  {
    name: 'Identity Syncs',
    cell: row => <IdentitySyncsCell identitySyncs={row.identitySyncs} />,
  },
  {
    name: 'Last Updated',
    cell: row => <TimestampCell timestamp={row.updatedAt} />,
    sortable: true,
    sortField: SORTABLE_ANALYTICS_FILE_FIELDS.updatedAt,
  },
  {
    button: true,
    cell: row => <ActionsCell row={row} />,
  },
];
